import React, { useEffect } from "react";
import {useDispatch, useSelector} from "react-redux";
import {loadGames} from "../actions/gamesAction";
//Components
import Game from "../components/Game";
import GameDetail from "../components/GameDetail";
//Styling and Animation
import styled from "styled-components";
import { motion, AnimatePresence, AnimateSharedLayout } from "framer-motion";
import { useLocation } from "react-router-dom";
import { fadeIn } from "../animation";


const Home = () => {
    //get current loaction
    const location = useLocation();
    const pathId = location.pathname.split("/")[2];
    //Fetch Game
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(loadGames());
    },[dispatch]);
    //get that data back
    const {popular, newGames, upcoming, searched} = useSelector(state => state.games);
    
    return(
        <GamesList variants={fadeIn} initial="hidden" animate="show">
            <AnimateSharedLayout type="crossfade">
              <AnimatePresence>
                {pathId && <GameDetail pathId={pathId}/>}
              </AnimatePresence>
              {searched.length ? (
                <div className="searched">
                    <h2>Searched Games</h2>
                    <Games>
                        {searched.map((game) => (
                            <Game 
                                name={game.name} 
                                released={game.released} 
                                id={game.id} 
                                image={game.background_image}
                                key={game.id}    
                                />
                        ))}
                    </Games> 
                </div> 
              ) : ""}
           <h2>Upcoming Games</h2>
           <Games>
               {upcoming.map((game) => (
                   <Game 
                      name={game.name} 
                      released={game.released} 
                      id={game.id} 
                      image={game.background_image}
                      key={game.id}    
                    />
               ))}
           </Games>
           <h2>Popular Games</h2>
           <Games>
               {popular.map((game) => (
                   <Game 
                      name={game.name} 
                      released={game.released} 
                      id={game.id} 
                      image={game.background_image}
                      key={game.id}    
                    />
               ))}
           </Games>
           <h2>New Games</h2>
           <Games>
               {newGames.map((game) => (
                   <Game 
                      name={game.name} 
                      released={game.released} 
                      id={game.id} 
                      image={game.background_image}
                      key={game.id}    
                    />
               ))}
           </Games>
         </AnimateSharedLayout>
        </GamesList>
    )
}

const GamesList = styled(motion.div)`
   padding: 0rem 5rem;
   h2{
       padding: 3rem 0rem;
   }
`;

const Games = styled(motion.div)`
    min-height: 50vh;
    display: grid;
    grid-template-columns: repeat(auto-fit,minmax(500px,1fr));
    grid-column-gap: 3rem;
    grid-row-gap: 5rem ;
`;

export default Home;